import React from "react";
import { useNavigate } from "react-router-dom";

import image1 from "../components/assets/unc-surgical04.jpg";
import image2 from "../components/assets/Boardroom2.jpg";
import image3 from "../components/assets/Automationsolutions.jpg";
import image4 from "../components/assets/Maskimage.jpg";

const PremiumPanel = ({ title, description, image, navigateTo, buttonColor }) => {
  const navigate = useNavigate();
  
  return (
    <div
      onClick={() => navigate(navigateTo)}
      className="group relative flex-1 min-h-[320px] lg:min-h-full cursor-pointer overflow-hidden rounded-3xl transition-all duration-700 lg:hover:flex-[2]"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-transform duration-[2000ms] group-hover:scale-110"
        style={{ backgroundImage: `url(${image})` }}
      ></div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60 group-hover:bg-black/40 transition duration-500"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-end h-full p-10 text-white">

        <h3 className="text-2xl font-bold mb-3 transform translate-y-6 group-hover:translate-y-0 transition duration-500">
          {title}
        </h3>

        <p className="text-gray-200 lg:max-w-xs opacity-0 lg:group-hover:opacity-100 transition duration-500">
          {description}
        </p>
        <button
          onClick={(e) => {
            e.stopPropagation();
            navigate(navigateTo);
          }}
          className="mt-6 w-fit px-6 py-2 rounded-full text-white opacity-0 group-hover:opacity-100 transition duration-500"
          style={{ backgroundColor: buttonColor }}
        >
          Explore
        </button>

      </div>
    </div>
  );
};

const SolutionsLayout = () => {
  return (
    <section className="maxWidthContainer mx-auto py-8 px-6">

      {/* Title */}
      <div className="text-center mb-20">
        <h2 className="text-4xl font-bold text-[#16213d] mb-6">
          Solutions Built for Modern Workspaces
        </h2>

        <p className="text-gray-600 max-w-2xl mx-auto">
          Discover powerful audio visual and collaboration solutions designed to
          transform how your organization communicates, collaborate, and deliver
          exceptional experiences.
        </p>
      </div>

      {/* Expanding Panels */}
      <div className="flex flex-col lg:flex-row gap-6 lg:h-[520px]">
        <PremiumPanel
          title="Interactive Technology"
          description="Transform presentations, classrooms, and meeting rooms with interactive displays and smart collaboration tools."
          image={image1}
          navigateTo="/interactiveTechnology"
          buttonColor="#f24b00"
        />

        <PremiumPanel
          title="Audio Visual Integration"
          description="Professional AV system design, installation, and integration for boardrooms, auditoriums, and command centers."
          image={image2}
          navigateTo="/avIntegration"
          buttonColor="#16213d"
        />

        <PremiumPanel
          title="Digital Media"
          description="Engage audiences using digital signage, media distribution platforms, and dynamic content solutions."
          image={image3}
          navigateTo="/digitalMedia"
          buttonColor="#f24b00"
        />

        <PremiumPanel
          title="Collaboration Solutions"
          description="Empower teams with advanced conferencing, hybrid meeting rooms, and collaboration technology."
          image={image4}
          navigateTo="/collaborationSolutions"
          buttonColor="#16213d"
        />
      </div>

    </section>
  );
};

export default SolutionsLayout;